const storedUser = (() => { try { return JSON.parse(localStorage.getItem('explorer_user')) } catch { return null } })()
const storedAuth = (() => { try { return JSON.parse(localStorage.getItem('explorer_auth')) } catch { return null } })()

const base = {
  state: {
    pathName: '',
    activeLang: 'cn',
    currentUser: storedUser || null,
    accessToken: (storedAuth && storedAuth.accessToken) || '',
    refreshToken: (storedAuth && storedAuth.refreshToken) || ''
  },
  mutations: {
    setPathName: (state, data) => {
      state.pathName = data
    },
    setActiveLang: (state, data) => {
      state.activeLang = data
    },
    setCurrentUser: (state, user) => {
      state.currentUser = user
      if (user) {
        localStorage.setItem('explorer_user', JSON.stringify(user))
      } else {
        localStorage.removeItem('explorer_user')
      }
    },
    // Store JWT tokens in state + localStorage
    setTokens: (state, { accessToken, refreshToken }) => {
      state.accessToken = accessToken || ''
      state.refreshToken = refreshToken || ''
      if (accessToken) {
        localStorage.setItem('explorer_auth', JSON.stringify({ accessToken, refreshToken }))
      } else {
        localStorage.removeItem('explorer_auth')
      }
    }
  }
}

export default base
